// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 5.5H22V14H12V15H14V22H8V15H10V12H20V7.5H19V11H2V2H19V5.5ZM10 20H12V17H10V20Z"}}]};

const FormatPainterFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-painter-filled',
    ref,
    icon: element,
  },
));

FormatPainterFilledIcon.displayName = 'FormatPainterFilledIcon';

export default FormatPainterFilledIcon;
